import PropTypes from 'prop-types'

import theme from 'theme'
import { getAttackStageColor } from 'components/attacks/utils/attack-stages'

const Dot = ({ stage, ...rest }) => (
  <div
    css={{
      backgroundColor: getAttackStageColor(stage),
      height: '0.75rem',
      width: '0.75rem',
      borderRadius: theme.borderRadius[2],
      flex: 'none'
    }}
    {...rest}
  />
)

Dot.propTypes = {
  stage: PropTypes.string
}

export default Dot
